export default {
	error: 'Error',
	warning: 'Warning',
	info: 'Note',
	success: 'Success',
	message: 'Message',
	close: 'Close',
	'form-description': 'Form fields marked with an asterisk (*) are mandatory.',
	new: 'New',
	'no-entries': 'No entries available.',
	'change-order': 'Change order of {{colLabel}}',
	'action-running': 'Action is running...',
	'action-done': 'Action done',
	pagination: 'Pagination',
	'page-first': 'Directly to the first page',
	'page-back': 'One page back',
	'page-next': 'One page further',
	'page-last': 'Directly to the last page',
	'entries-per-site': 'Entries per page',
	page: 'Page',
	'page-current': 'Page {{page}}',
	'page-selected': 'Page {{page}} is selected',
	'page-per-site': 'Entries per page',
	'nav-maximize': 'Maximize navigation',
	'nav-minimize': 'Minimize navigation',
	'logo-description': 'Logo {{orgShort}}. Federal eagle with flag staff and lettering {{orgLong}}',
	'open-link-in-tab': 'Opens in new tab.',
	'kolibri-logo': 'KoliBri logo',
	'table-pagination-label': 'Pagination for table {{label}}',
	'table-sort-order': 'Priority {{order}}',
	'avatar-alt': 'Avatar of {{name}}',
	'split-button-dropdown-label-open': 'Show options',
	'split-button-dropdown-label-close': 'Hide options',
	'toast-close-all': 'Close all notifications',
	'error-list': 'Error list',
	'error-list-message': 'Please correct the following errors',
	version: 'Version number',
	'table-visible-range': 'Entries {{start}} to {{end}} of {{total}}',
	'table-selection-all': 'Select all',
	'table-selection-none': 'Deselect all',
	'table-selection-indeterminate': 'Select all with partial selection',
	'table-settings': 'Table configuration',
	'table-settings-cancel': 'Cancel',
	'table-settings-apply': 'Apply',
	'table-settings-show-column': 'Show column {{column}}',
	'table-settings-column-width': '{{column}} width',
	'table-settings-move-up': 'Move {{column}} column up',
	'table-settings-move-down': 'Move {{column}} column down',
	'table-settings-error-all-invisible': 'At least one column must be visible.',
	'table-settings-column-not-hidable': 'cannot be hidden',
	dropdown: 'Dropdown',
	'nav-label-open': 'Submenu for {{label}} open',
	'nav-label-close': 'Submenu for {{label}} close',
	'close-alert': 'Close notification',
	'show-password': 'Show',
	'hide-password': 'Hide',
	'no-results-message': 'No results found.',
	'delete-selection': 'Delete selection',
	'filename-text': 'Choose a file or drop it here...',
	'data-browse-text': 'Browse',
	sort: 'sort',
	'pagination-position-top': 'top',
	'pagination-position-bottom': 'bottom',
	'character-limit-hint': 'You can enter up to {{limit}} characters',
	'character-limit-remaining': 'You have {{remaining}} characters remaining.',
	'character-limit-exceeded': 'You have {{over}} characters too many.',
	'character-counter-current': '{{current}} characters',
	'character-counter-current-of-max': '{{current}}/{{max}} characters',
	'character-counter-current-of-max-aria': '{{current}} of {{max}} characters',
	'live-value-bounded': '{{value}} of {{max}} {{unit}}',
	'live-value': '{{value}} {{unit}}',
	readonly: 'read-only',
	'meter-state-optimum': 'Optimum',
	'meter-state-suboptimal': 'Suboptimal',
	'meter-state-critical': 'Critical',
};
